<template>
  <div class="row">
    <div class="col-lg-12" v-if="result">
      <table class="table table-hover table-striped">
        <thead>
        <tr>
          <th>Rank</th>
          <th>Url</th>
          <th>Title</th>
          <th>Domain</th>
          <th v-tooltip="'Keywords'">KW</th>
          <th v-tooltip="'Referring Domains'">RD</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="site in result.data.sites" :key="'site-' + site.rank">
          <td>{{ site.rank }}</td>
          <td>{{ shorten(site.url, 50, '...') }} <a :href="site.url" target="_blank"><i class="fa fa-external-link"></i></a></td>
          <td>{{ site.title }}</td>
          <td>{{ site.domain }}</td>
          <td>{{ site.keywords.length }}</td>
          <td>{{ site.backlinks ? site.backlinks.referringDomains : '/' }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { String } from '../../../../../../mixins/helperMixin'

export default {
  props: ['result'],
  mixins: [String]
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Single/Tabs/PageEntity/Sites.vue